<main class="main-wrapper">


<router-outlet></router-outlet>
</main>
<app-online-footer></app-online-footer>

